import {
  EXERCISE_KEY,
  getTypeExerciseUtil,
  WORKOUT_EXERCISE_KEY,
  getCurrentWorkoutExerciseSelect
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'

export const getExerciseData = (exercise) => (state) => {
  const currentWorkoutExercise = getCurrentWorkoutExerciseSelect(state)

  return {
    equipment: getValueReduxUtil(exercise, EXERCISE_KEY.EQUIPMENT) || [],
    type: getTypeExerciseUtil(exercise),
    muscles: getValueReduxUtil(exercise, EXERCISE_KEY.MUSCLES) || [],
    level: getValueReduxUtil(exercise, EXERCISE_KEY.LEVEL),
    exerciseName: getValueReduxUtil(exercise, EXERCISE_KEY.NAME),
    force: getValueReduxUtil(exercise, EXERCISE_KEY.FORCE),
    secondaryMuscles: getValueReduxUtil(exercise, EXERCISE_KEY.SECONDARY_MUSCLES),
    setData: getValueReduxUtil(currentWorkoutExercise, WORKOUT_EXERCISE_KEY.SET_DATA),
    currentWorkoutExercise
  }
}
